module.exports = __webpack_public_path__ + "img/HD_hd_logo_2_9c393965b.png";